/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { StringConfig } from "./StringConfig";
import { BaseProperty } from "./BaseProperty";
export const StringProperty = core.serialization
    .object({
    config: StringConfig.optional(),
})
    .extend(BaseProperty);
